var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"xc-transparent"},[_c('input',{staticStyle:{"display":"none"},attrs:{"name":_vm.name},domProps:{"value":_vm.inputValue}}),_vm._t("input-before"),_vm._t("input",function(){return [_c('button',{staticClass:"xc-btn xc-btn-upload"},[_vm._v("上传")])]}),_vm._t("input-after")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }